import * as React from "react";
import { Control, useFieldArray, useWatch } from "react-hook-form";
import {
  Text,
  Grid,
  Title,
  Modal,
  ActionIcon,
  Button,
  Stack,
  Flex,
  Group,
  Divider,
} from "@mantine/core";
import { IconPlus, IconTrash } from "@tabler/icons-react";

import {
  CSelect,
  CTextInput,
  CCheckbox,
  CMultiSelect,
  CTextarea,
} from "@supportinitiative/react-hook-form-mantine";

import { UseCaseCVMContext } from "../UseCaseCVMContext";
import {
  getDataset,
  getDatasetColumnsLOV,
  columnTypes,
  getDatasetsLOV,
  getColumnsLOV,
  getColumnsToMergeLOV,
} from "../UseCaseUtils";
import { useDatasets } from "../../hooks";

const options = [
  { label: "D001", value: "D001" },
  { label: "D002", value: "D002" },
  { label: "D003", value: "D003" },
  { label: "D004", value: "D004" },
  { label: "D005", value: "D005" },
  { label: "D006", value: "D006" },
  { label: "D007", value: "D007" },
  { label: "D008", value: "D008" },
  { label: "D009", value: "D009" },
  { label: "D010", value: "D010" },
  { label: "D011", value: "D011" },
  { label: "D012", value: "D012" },
  { label: "D013", value: "D013" },
  { label: "D014", value: "D014" },
  { label: "D015", value: "D015" },
  { label: "D016", value: "D016" },
  { label: "D017", value: "D017" },
  { label: "D018", value: "D018" },
  { label: "D019", value: "D019" },
  { label: "D020", value: "D020" },
  { label: "D021", value: "D021" },
  { label: "D022", value: "D022" },
  { label: "D023", value: "D023" },
  { label: "D024", value: "D024" },
  { label: "D025", value: "D025" },
  { label: "D026", value: "D026" },
  { label: "D027", value: "D027" },
  { label: "D028", value: "D028" },
  { label: "D029", value: "D029" },
  { label: "D030", value: "D030" },
  { label: "D031", value: "D031" },
  { label: "D032", value: "D032" },
  { label: "D033", value: "D033" },
  { label: "D034", value: "D034" },
  { label: "D035", value: "D035" },
  { label: "D036", value: "D036" },
  { label: "D037", value: "D037" },
  { label: "D038", value: "D038" },
  { label: "D039", value: "D039" },
  { label: "D040", value: "D040" },
  { label: "D041", value: "D041" },
  { label: "D042", value: "D042" },
  { label: "D043", value: "D043" },
  { label: "D044", value: "D044" },
  { label: "D045", value: "D045" },
  { label: "D046", value: "D046" },
  { label: "D047", value: "D047" },
  { label: "D048", value: "D048" },
  { label: "D049", value: "D049" },
  { label: "D050", value: "D050" },
  { label: "D051", value: "D051" },
  { label: "D052", value: "D052" },
  { label: "D053", value: "D053" },
  { label: "D054", value: "D054" },
  { label: "D055", value: "D055" },
  { label: "D056", value: "D056" },
  { label: "D057", value: "D057" },
  { label: "D058", value: "D058" },
  { label: "D059", value: "D059" },
  { label: "D060", value: "D060" },
  { label: "D061", value: "D061" },
  { label: "D062", value: "D062" },
  { label: "D063", value: "D063" },
  { label: "D064", value: "D064" },
  { label: "D065", value: "D065" },
  { label: "D066", value: "D066" },
  { label: "D067", value: "D067" },
  { label: "D068", value: "D068" },
  { label: "D069", value: "D069" },
  { label: "D070", value: "D070" },
  { label: "D071", value: "D071" },
  { label: "D072", value: "D072" },
  { label: "D073", value: "D073" },
  { label: "D074", value: "D074" },
  { label: "D075", value: "D075" },
  { label: "D076", value: "D076" },
  { label: "D077", value: "D077" },
  { label: "D078", value: "D078" },
  { label: "D079", value: "D079" },
  { label: "D080", value: "D080" },
  { label: "D081", value: "D081" },
  { label: "D082", value: "D082" },
  { label: "D083", value: "D083" },
  { label: "D084", value: "D084" },
  { label: "D085", value: "D085" },
  { label: "D086", value: "D086" },
  { label: "D087", value: "D087" },
  { label: "D088", value: "D088" },
  { label: "D089", value: "D089" },
  { label: "D090", value: "D090" },
  { label: "D091", value: "D091" },
  { label: "D092", value: "D092" },
  { label: "D093", value: "D093" },
  { label: "D094", value: "D094" },
  { label: "D095", value: "D095" },
  { label: "D096", value: "D096" },
  { label: "D097", value: "D097" },
  { label: "D098", value: "D098" },
  { label: "D099", value: "D099" },
  { label: "D100", value: "D100" },
];

function ReconDatasetCVM({
  name,
  control,
}: {
  name: `definition.recons.${number}.definition.datasets.${number}`;
  control: Control<any>;
}) {
  const { state: useCaseFormState } = React.useContext(UseCaseCVMContext);
  const { data: datasets } = useDatasets(useCaseFormState.entityId);

  let [isOpen, setIsOpen] = React.useState(false);
  // let [relationship, setRelationship] = React.useState<RelationshipType>();

  const additionalColumnsArray = useFieldArray({
    control,
    name: `${name}.additionalColumns`,
    keyName: "key",
  });
  /* 
  const masterDataset = useWatch({
    control,
    name: "definition.masterDataset.id",
  }); */

  const reconDataset = useWatch({
    control,
    name: `${name}.datasetId`,
  });

  const reconDatasetName = useWatch({
    control,
    name: `${name}.name`,
  });

  const columns = useWatch({
    control,
    name: `${name}.columns`,
  });

  const additionalColumns = useWatch({
    control,
    name: `${name}.additionalColumns`,
  });

  React.useEffect(() => {
    if (reconDataset) {
      let dataset = getDataset(datasets, reconDataset);
      if (dataset) {
        if (!columns || columns.length === 0) {
          // Only set columns when existing columns are empty
          let datasetColumns = (dataset.definition.columns || []).map((col) => {
            return col.name;
          });
          useCaseFormState.setValue(`${name}.columns`, datasetColumns);
        }
      }
    }
  }, [reconDataset]);

  return (
    <>
      <Button
        fullWidth
        variant="default"
        onClick={() => {
          setIsOpen(!isOpen);
        }}
      >
        <Text>{reconDatasetName ? reconDatasetName : "Dataset"}</Text>
      </Button>

      <Modal
        centered
        size={"xl"}
        opened={isOpen}
        onClose={() => setIsOpen(!isOpen)}
        title={<Title order={4}>{"Dataset"}</Title>}
      >
        <Stack gap="0">
          <Grid align="stretch" gutter={"xs"} mb="lg">
            <Grid.Col span={6}>
              <CSelect
                name={`${name}.id`}
                label="ID"
                control={control}
                clearable
                required
                data={options}
                disabled={useCaseFormState.actionOptions.disableAll}
              />
            </Grid.Col>
            <Grid.Col span={6}>
              <CTextInput
                name={`${name}.name`}
                label="Name"
                control={control}
                required
                disabled={useCaseFormState.actionOptions.disableAll}
              />
            </Grid.Col>
          </Grid>
          <Grid align="stretch" gutter={"xs"} mb="lg">
            <Grid.Col span={12}>
              <CTextarea
                name={`${name}.description`}
                label="Description"
                control={control}
                disabled={useCaseFormState.actionOptions.disableAll}
              />
            </Grid.Col>
          </Grid>
          <Divider label="Dataset" />

          <Grid align="stretch" gutter={"xs"} mb="xs">
            <Grid.Col span={12}>
              <CSelect
                name={`${name}.datasetId`}
                label="Dataset"
                control={control}
                clearable
                data={getDatasetsLOV(datasets)}
                required
                disabled={useCaseFormState.actionOptions.disableAll}
              />
            </Grid.Col>
          </Grid>

          <Grid align="stretch" gutter={"xs"} mb="xs">
            <Grid.Col span={12}>
              <CMultiSelect
                name={`${name}.columns`}
                control={control}
                searchable
                required
                label="Columns"
                data={getDatasetColumnsLOV(getDataset(datasets, reconDataset))}
                disabled={useCaseFormState.actionOptions.disableAll}
              />
            </Grid.Col>
          </Grid>

          <Group align="center">
            <Text fw={500} style={{ fontSize: "14px" }}>
              Additional Columns
            </Text>
            <ActionIcon
              size="sm"
              variant="white"
              color="gray"
              onClick={() => {
                additionalColumnsArray.append({
                  name: "",
                  type: "TEXT",
                  label: "",
                  genFunction: "",
                  notNull: "NO",
                });
              }}
              disabled={useCaseFormState.actionOptions.disableAll}
            >
              <IconPlus />
            </ActionIcon>
          </Group>

          {additionalColumnsArray.fields.length === 0 ? (
            <Grid align="stretch" gutter={"xs"} mb="xs">
              <Grid.Col span={12}>
                <Divider
                  label="No Additional Columns"
                  mt="xs"
                  labelPosition="left"
                />
              </Grid.Col>
            </Grid>
          ) : (
            <Stack mb="xs">
              <Grid align="stretch" gutter={"xs"} mt="xs">
                <Grid.Col span={12}>
                  {additionalColumnsArray.fields.map((field, index) => {
                    return (
                      <Grid
                        align="stretch"
                        gutter={"xs"}
                        mb="xs"
                        key={field.key}
                      >
                        <Grid.Col span={2}>
                          <CTextInput
                            name={`${name}.additionalColumns.${index}.name`}
                            control={control}
                            showErrorText={false}
                            label={index === 0 ? "Name" : ""}
                            required
                            disabled={useCaseFormState.actionOptions.disableAll}
                          />
                        </Grid.Col>
                        <Grid.Col span={2}>
                          <CSelect
                            name={`${name}.additionalColumns.${index}.type`}
                            control={control}
                            label={index === 0 ? "Type" : ""}
                            data={columnTypes}
                            showErrorText={false}
                            required
                            disabled={useCaseFormState.actionOptions.disableAll}
                          />
                        </Grid.Col>
                        <Grid.Col span={2}>
                          <CTextInput
                            name={`${name}.additionalColumns.${index}.label`}
                            control={control}
                            showErrorText={false}
                            label={index === 0 ? "Label" : ""}
                            disabled={useCaseFormState.actionOptions.disableAll}
                          />
                        </Grid.Col>
                        <Grid.Col span={2}>
                          <CTextInput
                            name={`${name}.additionalColumns.${index}.genFunction`}
                            control={control}
                            showErrorText={false}
                            label={index === 0 ? "Gen Function" : ""}
                            disabled={useCaseFormState.actionOptions.disableAll}
                          />
                        </Grid.Col>
                        <Grid.Col
                          span={1}
                          style={{ display: "flex", alignItems: "flex-end" }}
                        >
                          <CTextInput
                            name={`${name}.additionalColumns.${index}.id`}
                            control={control}
                            label={index === 0 ? "Id" : ""}
                            disabled={true}
                          />
                        </Grid.Col>
                        <Grid.Col
                          span={2}
                          style={{ display: "flex", alignItems: "flex-end" }}
                        >
                          <CCheckbox
                            name={`${name}.additionalColumns.${index}.notNull`}
                            control={control}
                            label="Not Null"
                            trueValue="YES"
                            falseValue="NO"
                            disabled={useCaseFormState.actionOptions.disableAll}
                          />
                        </Grid.Col>
                        <Grid.Col
                          span={1}
                          style={{ display: "flex", alignItems: "flex-end" }}
                        >
                          <ActionIcon
                            size="sm"
                            variant="white"
                            color="gray"
                            onClick={() => {
                              additionalColumnsArray.remove(index);
                            }}
                            disabled={useCaseFormState.actionOptions.disableAll}
                          >
                            <IconTrash />
                          </ActionIcon>
                        </Grid.Col>
                      </Grid>
                    );
                  })}
                </Grid.Col>
              </Grid>
            </Stack>
          )}

          <Grid align="stretch" gutter={"xs"} mb="lg">
            <Grid.Col span={12}>
              <CMultiSelect
                name={`${name}.displayColumns`}
                control={control}
                searchable
                label="Display Columns"
                data={getColumnsLOV(
                  getDataset(datasets, reconDataset),
                  columns || [],
                  additionalColumns
                )}
                disabled={useCaseFormState.actionOptions.disableAll}
              />
            </Grid.Col>
          </Grid>

          <Divider label="Match" />

          <Grid align="stretch" gutter={"xs"} mb="lg">
            <Grid.Col span={6} style={{ alignItems: "flex-end" }}>
              <CCheckbox
                name={`${name}.allowMatch`}
                control={control}
                label="Allow Match"
                trueValue="YES"
                falseValue="NO"
                disabled={useCaseFormState.actionOptions.disableAll}
              />
            </Grid.Col>
            <Grid.Col span={6}>
              <CMultiSelect
                name={`${name}.resetMatchOnChangeOf`}
                control={control}
                searchable
                label="Reset Match on Change of"
                data={getColumnsToMergeLOV(
                  getDataset(datasets, reconDataset),
                  columns || [],
                  additionalColumns
                )}
                disabled={useCaseFormState.actionOptions.disableAll}
              />
            </Grid.Col>
          </Grid>

          <Divider label="Access" />

          <Grid align="stretch" gutter={"xs"} mb="lg">
            <Grid.Col span={12}>
              <CTextInput
                name={`${name}.access`}
                control={control}
                label="Access"
                disabled={useCaseFormState.actionOptions.disableAll}
              />
            </Grid.Col>
          </Grid>

          <Grid align="stretch" gutter={"xs"} mt="xs">
            <Grid.Col span={2}>
              <Button color="teal" fullWidth onClick={() => setIsOpen(!isOpen)}>
                Ok
              </Button>
            </Grid.Col>
          </Grid>
        </Stack>
      </Modal>
    </>
  );
}

export default ReconDatasetCVM;
